import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers } = CommonParameters;

export const paymentSettingsFrequency: IMcAppType = {
  name: "paymentSettingsFrequency",
  path: "/my/payment-settings/frequency",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Payment frequency for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Payment frequency",
  parent: Tab.MORE,

  conditions: {
    intent: "paymentSettingsFrequency",
    customerType: CustomerType.kraken,
  },
};

export const paymentSettingsFrequencySetup: IMcAppType = {
  name: "paymentSettingsFrequencySetup",
  path: "/my/payment-settings/frequency/setup",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Payment frequency for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Payment frequency",
  parent: Tab.MORE,

  conditions: {
    intent: "paymentSettingsFrequencySetup",
    customerType: CustomerType.kraken,
  },
};
